export default class CancellationToken {
    cancelled = false

    isCancelled() {
        return this.cancelled === true
    }

    cancel() {
        this.cancelled = true
    }
}
